import { render, staticRenderFns } from "./PremiumBtn.vue?vue&type=template&id=0dec78fa&"
import script from "./PremiumBtn.vue?vue&type=script&lang=ts&"
export * from "./PremiumBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports